import { Component } from 'global/interfaces/component.interface';
import ControllerBase from 'global/js/ControllerBase';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';
import { AtomButtonEvents } from 'wolf/components/atoms/a-button/a-button.events';
import { FilterDataProps } from 'wolf/components/organisms/o-job-offers/o-job-offers.controller';
import { MoleculeJobOfferAreaContentProps } from '../m-job-offer-area-content/m-job-offer-area-content.data';

const jobOfferAreaContentTemplate = require('components/molecules/m-job-offer-area-content/m-job-offer-area-content.template.twig') as (
	data: Component<MoleculeJobOfferAreaContentProps>,
) => string;

export default class ControllerJobOfferArea extends ControllerBase {
	private loadBtn: HTMLAnchorElement;
	private jobsArea: HTMLDivElement;
	private jobFiltersContainer: HTMLDivElement;
	private areaTypeName: string;
	private jobsAreaUrl: string;
	/** Filter values */
	private filterValues: FilterDataProps;
	private areaContent: MoleculeJobOfferAreaContentProps;

	constructor(element: HTMLElement) {
		super(element);
		this.loadBtn = this.$element.querySelector('.js-job-wrapper .js-load-button .a-button') as HTMLAnchorElement;
		this.jobsArea = this.$element.querySelector('.js-job-wrapper') as HTMLDivElement;
		this.jobFiltersContainer = document.querySelector('.js-job-offer__filter-container') as HTMLDivElement;
		this.areaTypeName = this.$element.dataset.areaName || '';
		this.jobsAreaUrl = this.$element.dataset.jobsAreaUrl || '';

		this.init();
	}

	private init() {
		this.filterValues = {
			selects: [],
			search: ''
		}
		this.loadBtn && this.loadBtn.addEventListener(AtomButtonEvents.buttonClicked, (e: CustomEvent<Event | MouseEvent>) => this.loadMoreOffers(e));

	}

	private setFilterData() {
		const search = this.jobFiltersContainer.querySelector('input.js-search-input') as HTMLInputElement;
		const inputs = this.jobFiltersContainer.querySelectorAll('select.js-select');

		if (search) {
			this.filterValues.search = search.value || '';
		}

		inputs.forEach((input: HTMLSelectElement) => {
			this.filterValues.selects.push({ key: input.name, value: input.value })
		})

	}

	/**
	 * Detects event from button and triggers AJAX call
	 */
	private loadMoreOffers(e: CustomEvent<Event | MouseEvent>): void {
		if (e && e.detail) {
			e.detail.preventDefault();

			this.setFilterData();


			this.getJobs()
				.then((response) => {
					this.areaContent = response && response.data;
					this.loadNewContent();
				})
				.catch((err) => {
					console.error(err);
				});
		}
	}

	/**
	 * Renders loaded job offers
	 */
	private loadNewContent(): void {
		const areaToRender = jobOfferAreaContentTemplate({
			data: this.areaContent,
		});

		this.jobsArea && this.domUtils.renderDomElementInHTMLElement(this.jobsArea, areaToRender);
	}

	/**
	 * AJAX call
	 */
	private async getJobs() {
		const url = new URL(this.jobsAreaUrl);

		if (this.filterValues.search) {
			url.searchParams.append('search', this.filterValues.search)
		}

		if (this.filterValues.selects) {
			this.filterValues.selects.forEach(filter => {
				if (filter.value) {
					url.searchParams.append(filter.key, filter.value)
				}
			})
		}

		url.searchParams.append('areaType', this.areaTypeName);

		const response = await fetch(url.toString());

		return await response.json();
	}

}
